//synchronized with backend type OBJECT_TYPES: https://github.com/ArtecGroup/artec_cloud/blob/master/app/models/version.rb
export enum ObjectItemType {
  Scan = 1,
  Model = 2,
  Group = 4,
  Cad = 6,
  PointCloud = 7,
  PhotoSet = 8,
}
export enum MeasureItemType {
  Distance,
  SectionGroup,
  DistanceMap,
}
//synchronized with backend type CAD_OBJECT_TYPES: https://github.com/ArtecGroup/artec_cloud/blob/master/app/models/version.rb
export enum CadType {
  Model = 1,
  Cylinder = 2,
  Cone = 3,
  TruncatedCone = 4,
  Sphere = 5,
  Plane = 6,
  Torus = 7,
  Freeform = 8,
  Undefined = 9,
}
export enum PhotoState {
  Default,
  Hovered,
  Active,
}

export interface IBaseItem {
  id: string;
  uuid: string;
  name: string;
  visible: boolean;
}
export interface IGroupableItem extends IBaseItem {
  groupID?: string; //missing groupID means than item is not grouped
}
export interface IGroupItem extends IGroupableItem {
  type: ObjectItemType.Group;
  color: string;
}
export interface IModelItem extends IGroupableItem {
  type: ObjectItemType.Model;

  color: string;

  polygons: number;
  vertices: number;
  scanner?: string; //scanner could be unknown
  size: number;
  isHD: boolean;
  textured: boolean;
}
export interface IScanItem extends IGroupableItem {
  color: string;

  polygons: number;
  vertices: number;
  scanner?: string; //scanner could be unknown
  frames: number;
  texturedFrames: number;
  size: number;

  isHD: boolean;
  hasrawgeometry: boolean;
  targetRawScan?: string; //only if has raw geometry

  globalapplied: boolean;
  maxError?: number; //registration error is absent if globalapplied: false
}
export interface ISimpleScanItem extends IScanItem {
  type: ObjectItemType.Scan;
}
export interface IPointCloudScanItem extends IScanItem {
  type: ObjectItemType.PointCloud;
}
export interface IBaseCadItem extends IGroupableItem {
  type: ObjectItemType.Cad;

  color: string;

  polygons: number;
  vertices: number;
  size: number;
}
export interface ICadModel extends IBaseCadItem {
  cadType: CadType.Model;

  facesCount: number;
}
export interface ICadCylinder extends IBaseCadItem {
  cadType: CadType.Cylinder;

  radius: number;
  height: number;
}
export interface ICadCone extends IBaseCadItem {
  cadType: CadType.Cone;

  radius: number;
  height: number;
  angle: number;
}
export interface ICadTruncatedCone extends IBaseCadItem {
  cadType: CadType.TruncatedCone;

  smallRadius: number;
  largeRadius: number;
  height: number;
  angle: number;
}
export interface ICadSphere extends IBaseCadItem {
  cadType: CadType.Sphere;

  radius: number;
}
export interface ICadPlane extends IBaseCadItem {
  cadType: CadType.Plane;
}
export interface ICadTorus extends IBaseCadItem {
  cadType: CadType.Torus;

  majorRadius: number;
  minorRadius: number;
}
export interface ICadFreeform extends IBaseCadItem {
  cadType: CadType.Freeform;

  uOrder: number;
  vOrder: number;
  uPointsCount: number;
  vPointsCount: number;
}
export interface ICadUndefined extends IBaseCadItem {
  cadType: CadType.Undefined;
}

export type PhotoDescriptor = {
  id: string,
  name: string,
  state: PhotoState;
  size: number;
  camera?: string; //could be unknown
  focalLength?: number; //could be unknown

  registered: boolean;
  regError?: number; //field is present only for registered photo
}
export interface IPhotoSetItem extends IGroupableItem {
  type: ObjectItemType.PhotoSet;

  registered: boolean;
  //fields are present only for registered photoSets
  registrationTarget?: string; //target can be absent without the reason even for registered photoSet
  maxError?: number;
  failedPhotos?: number;

  totalPhotos: number;
  totalSize: number;
  camera?: string; //could be unknown
  focalLength?: number //could be unknown

  photos?: PhotoDescriptor[]; //this field will be uninitialized until photoSet becomes visible
}
export interface IBaseMeasureItem extends IBaseItem {
  affiliation?: string[]; //affiliation objects can be removed from project
}
export interface IDistanceMeasure extends IBaseMeasureItem {
  type: MeasureItemType.Distance;

  selected: boolean;
  value?: number; //this field could be uninitialized until measure becomes visible (only for old projects)
}

export type ContourDescriptor = {
  visible: boolean;
  selected: boolean;

  //these fields could be uninitialized until section group becomes visible (only for old projects)
  area?: number;
  perimeter?: number;
}
export type SectionDescriptor = {
  visible: boolean;
  selected: boolean;
  contours: ContourDescriptor[];

  //these fields could be uninitialized until section group becomes visible (only for old projects)
  volume?: number;
  surfaceArea?: number;
}
export interface ISectionGroupMeasure extends IBaseMeasureItem {
  type: MeasureItemType.SectionGroup;

  selected: boolean;
  planes: number;
  distance: number;
  direction: string;
  sections: SectionDescriptor[];
}

export interface IDistanceMapMeasure extends IBaseMeasureItem {
  type: MeasureItemType.DistanceMap;

  reference?: string; //referenced object can be removed from project
  searchDistance: number;
  RMSD: number;
  expRange: number;
  expValue: number;
  meanAbsDeviation: number;
  meanAbsDistance: number;
}

export type ICadItem = ICadModel | ICadCylinder | ICadCone | ICadTruncatedCone | ICadSphere | ICadPlane | ICadTorus | ICadFreeform | ICadUndefined;
export type IObjectItem = IGroupItem | IModelItem | ISimpleScanItem | IPointCloudScanItem | ICadItem | IPhotoSetItem;
export type IMeasureItem = IDistanceMeasure | ISectionGroupMeasure | IDistanceMapMeasure;
export type IOrderingItem = {
  id: string;
}

export interface IProjectContent {
  objects: IObjectItem[];
  measures: IMeasureItem[];
  ordering: IOrderingItem[];

  clone(): IProjectContent;
}
